import { render, staticRenderFns } from "./FormRecipientsTypeTable.vue?vue&type=template&id=7e632fa1&"
import script from "./FormRecipientsTypeTable.vue?vue&type=script&lang=js&"
export * from "./FormRecipientsTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports